module.exports = "<div class=\"modal-header\">\n  <h2>Istruzioni per l'attivazione</h2>\n</div>\n<ol class=\"elenco-left\">\n  <li>Aver configurato il punto vendita</li>\n  <li>Assicurarsi che l'indirizzo del punto vendita inserito sia il medesimo associato con la licenza iPratico</li>\n</ol>  \n<p>Riceverà a breve una telefonata da parte di uno dei nostri operatori per concludere l'attivazione.</p>\n<footer>\n    <button class=\"button\" ng-click=\"activate()\">Richiedi l'attivazione</button>\n</footer>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/services/activations/iPratico.modal.html
 ** module id = 494
 ** module chunks = 0
 **/